import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import './index.css';

// Load centralized theme stylesheet dynamically
const loadCentralizedTheme = (): void => {
    const themeUrl = process.env.REACT_APP_SHARED_CSS_URL;
    if (themeUrl) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `${themeUrl}/assets/styles/theme-common.2.0.css`;
        link.id = 'centralized-theme';
        // Insert before other stylesheets to allow overrides
        const firstLink = document.querySelector('link[rel="stylesheet"]');
        if (firstLink && firstLink.parentNode) {
            firstLink.parentNode.insertBefore(link, firstLink);
        } else {
            document.head.appendChild(link);
        }
    } else {
        console.warn('REACT_APP_SHARED_CSS_URL is not defined. Centralized theme will not be loaded.');
    }
};

// Load theme before rendering the app
loadCentralizedTheme();

import App from './App';
import { HashRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import React from 'react';
import { render } from 'react-dom';
import reportWebVitals from './reportWebVitals';

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENTID ?? '',
        authority: `https://${process.env.REACT_APP_AUTHORITY_DOMAIN}/${process.env.REACT_APP_B2C_TENANT}.onmicrosoft.com/B2C_1A_SIGNIN_ONLY`,
        knownAuthorities: [`https://${process.env.REACT_APP_AUTHORITY_DOMAIN}`],
        redirectUri: process.env.REACT_APP_BASE_URL,
        postLogoutRedirectUri: process.env.REACT_APP_BASE_URL,
    },

    cache: {
        cacheLocation: 'sessionStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};
const msalContext = await PublicClientApplication.createPublicClientApplication(msalConfig);

render(
    <React.StrictMode>
        <MsalProvider instance={msalContext}>
            <HashRouter>
                <App />
            </HashRouter>
        </MsalProvider>
    </React.StrictMode>,
    document.getElementById('page-top')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
